import dictionary from '@/common/dictionary.js'
import {
  Toast
} from 'vant'
import {
  ShowInfo
} from '@/api/common'

export function searchDictionary(value, name) {
  if (arguments.length === 1) return dictionary[value].options || []; //  如果参数只有一个，获取对应的arr
  const arr = dictionary[name].options || [];
  let result = ''
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].value == value) {
      result = arr[i].label
      break
    }
  }
  return result;
}
export function seeLabel(value, arr) {
  if (!arr) return '';
  let result = '';
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].value == value) {
      result = arr[i].label;
      break;
    }
  }
  return result;
}
export const dateFmt = function(date, fmt = 'YYYY-MM-DD HH:mm:ss') {
  if (!date) {
    return ''
  }
  if (typeof date === 'string') {
    date = new Date(date.replace(/-/g, '/'))
  }
  if (typeof date === 'number') {
    date = new Date(date)
  }
  var o = {
    'M+': date.getMonth() + 1,
    'D+': date.getDate(),
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  var week = {
    '0': '\u65e5',
    '1': '\u4e00',
    '2': '\u4e8c',
    '3': '\u4e09',
    '4': '\u56db',
    '5': '\u4e94',
    '6': '\u516d'
  }
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') + week[date.getDay() + ''])
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

export function currencyFmt(value, n) {
  if (typeof value !== 'string' && typeof value !== 'number') return '';
  if (isNaN(Number(value))) return '';
  n = n > 0 && n <= 20 ? n : 2;
  value = parseFloat((value + '').replace(/[^\d\.-]/g, '')).toFixed(n) + '';
  const l = value.split('.')[0];
  const r = value.split('.')[1];
  return '\u00a5' + l + '.' + r;
}

export function toJSON(val) {
  return val == null ? '' : typeof val === 'object' ? JSON.stringify(val, null, 2) : String(val)
}

export function dateRange(start, end, time) { //  时间范围判断 true:在规定范围内
  start = new Date(start).getTime() / 1000;
  end = new Date(end).getTime() / 1000;
  const range = parseInt(end - start); //  秒数
  if (range >= time) {
    return false;
  } else {
    return true;
  }
}

export function typeOf(obj) {
  const toString = Object.prototype.toString;
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  };
  return map[toString.call(obj)];
}

// deepCopy
export function deepCopy(data) {
  const t = typeOf(data);
  let o;
  if (t === 'array') {
    o = [];
  } else if (t === 'object') {
    o = {};
  } else {
    return data;
  }
  if (t === 'array') {
    for (let i = 0; i < data.length; i++) {
      o.push(deepCopy(data[i]));
    }
  } else if (t === 'object') {
    for (let i in data) {
      o[i] = deepCopy(data[i]);
    }
  }
  return o;
}

//  http发送之前对数据处理，去除两边空字符串，默认过滤空字符串字段的发送，type为true则不过滤
export function objReduce(data, type) {
  var o = deepCopy(data);
  for (var k in o) {
    if (typeOf(o[k]) === 'string') {
      o[k] = o[k].trim()
      if (o[k] === '' && !type) {
        delete o[k];
      }
    } else if (typeOf(o[k]) === 'object') {
      objReduce(o[k])
    }
  }
  return o
}

export function verify(rules, send) {
  /**
   rules: Object
   eg: 
    {
      mobile: {
        // 'required' or 正则 or function
        rule: function(input){
          return true or false
        }, 
        // String
        msg: '请输入正确的手机号'
      }
    }
   */
  for (let prop in rules) {
    const rule = rules[prop].rule;
    const msg = rules[prop].msg;
    const val = send[prop];
    const res = rulesHandle(val, rule);
    if (!res) {
      Toast(msg);
      return false;
    }
  }
  return true;

  function rulesHandle(val, rule) {
    if (rule === 'required') {
      return !(val === '' || val === null || val === undefined)
    } else if (typeof rule === 'function') {
      return rule(val);
    } else if (!rule.test(val)) {
      return false;
    }
    return true;
  }
}

export function setCookie(name, value, exdays) {
  exdays = exdays || 1;
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + "; " + expires;
}

export function getCookie(name) {
  var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  var arr = document.cookie.match(reg)
  if (arr) {
    return decodeURIComponent(arr[2]);
  } else {
    return null;
  }
}

export function delCookie(name) {
  setCookie(name, "", -1);
}

export function getUINFO(cb) {
  // 有时候不是从登陆页面登陆的，有扫描登录的，这种请求一次
  // var uinfo = getCookie('UINFO');
  // if (!uinfo) {
  //   ShowInfo().then(res => {
  //     // 这里服务端设置个cookie
  //     cb && cb(JSON.parse(getCookie('UINFO')))
  //   })
  // } else {
  //   cb && cb(JSON.parse(uinfo))
  // }
  ShowInfo().then(res => {
    // 这里服务端设置个cookie
    cb && cb(JSON.parse(getCookie('UINFO')))
  })
}

export function dealNumber(num) { // 处理小数
  return Math.round(num * 100) / 100
}

export function timeRange(start, end) {
  const range = (new Date(end).getTime()) - (new Date(start).getTime())
  if (range <= 0) {
    return '00:00:00';
  }
  var hours = parseInt(range / 1000 / 60 / 60 % 24, 10);
  var minutes = parseInt(range / 1000 / 60 % 60, 10);
  var seconds = parseInt(range / 1000 % 60, 10);
  hours = checkTime(hours);
  minutes = checkTime(minutes);
  seconds = checkTime(seconds);
  return `${hours}:${minutes}:${seconds}`;

  function checkTime(i) {
    return i < 10 ? `0${i}` : i;
  }
}
export function setWXPayPath(path) {
  /**
   * 页面刷新：ios微信中链接拿到真正的链接
   * 添加？： 解决微信支付目录授权问题
   */
  let [left] = location.href.split('#');
  left = left.split('?')[0];
  location.href = `${left}?#${path}`
}



// WEBPACK FOOTER //
// ./src/common/utils.js